import {
  SHOW_MODAL,
  CLEAR_MODAL,
  GLOBAL_REQ_CANCEL,
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION
} from './Types';

/**
 * First cancels existing/in process API actions, then fires off an action
 * @param  {[type]} action [description]
 * @return [type]          [description]
 */
export const cancelApiActionsAndFire = action => {
  return dispatch => {
    dispatch({
      type: GLOBAL_REQ_CANCEL
    });
    dispatch(action);
  };
};

/**
 * Cancel API actions
 */
export const cancelApiActions = () => ({
  type: GLOBAL_REQ_CANCEL
});

/**
 *
 * @param {*} type
 * @param {*} initialValue
 */
export const showModal = (type, initialValue) => {
  return dispatch => {
    const action = {
      type: SHOW_MODAL,
      payload: {
        type,
        initialValue
      }
    };

    dispatch(action);
  };
};

/**
 * Cancel a modal
 */
export const clearModal = type => {
  return dispatch => {
    const action = {
      type: CLEAR_MODAL,
      payload: type
    };

    dispatch(action);
  };
};

/**
 * Show a notification
 */
export const showNotification = (
  message,
  options = { timeout: 2000, type: 'success' }
) => {
  return dispatch => {
    const { timeout = 2000, type = 'success', indefinite = false } = options;
    const action = {
      type: SHOW_NOTIFICATION,
      payload: {
        show: true,
        message,
        type
      }
    };

    dispatch(action);

    if (!indefinite) {
      setTimeout(() => {
        dispatch(clearNotification());
      }, timeout);
    }
  };
};

/**
 * Clear a notification
 */
export const clearNotification = () => {
  return dispatch => {
    const action = {
      type: CLEAR_NOTIFICATION,
      payload: {
        show: false
      }
    };

    dispatch(action);
  };
};
